<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $tc('messages.teacher_fouls', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.create'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <div class="md:grid md:grid-cols-3 md:gap-6">
                <div class="mt-5 md:mt-0 md:col-span-2">
                    <div class="md:grid md:grid-cols-6 md:gap-6">
                        <div class="sm:col-span-2">
                            <div class="mt-1">
                                <FormLabel :value="$t('messages.date')" for="date" />
                                <FormInput
                                    required
                                    id="date"
                                    v-model="form.date"
                                    name="date"
                                    type="date"
                                    class="w-full mt-1"
                                />
                                <FormError :value="form.errors.date" class="mt-2" />
                            </div>
                        </div>

                        <div class="sm:col-span-6">
                            <div class="mt-1">
                                <FormLabel :value="$t('messages.comment')" for="comment" />
                                <FormTextarea
                                    rows="3"
                                    id="comment"
                                    v-model="form.comment"
                                    name="comment"
                                    type="text"
                                    class="mt-1 w-full"
                                />
                                <FormError :value="form.errors.comment" class="mt-2" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-5 md:mt-0 bg-gray-100">
                    <GroupStudentsSelector :students="options.teachers" v-model="form.teacher_ids" />
                </div>
            </div>

            <div class="flex justify-end mt-5">
                <AppButton element="button" type="submit" :disabled="form.processing">
                    <template v-if="form.teacher_ids.length < 2">
                        {{ $t('messages.create') }}
                    </template>
                    <template v-else>
                        {{ $t('messages.create_multiple') }}
                    </template>
                    <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                </AppButton>
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormTextarea from '@/components/Forms/FormTextarea.vue';
import GroupStudentsSelector from '@/components/GroupStudentsSelector.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    components: {
        AppButton,
        PanelPage,
        FormInput,
        FormLabel,
        FormError,
        FormTextarea,
        GroupStudentsSelector,
    },
    layout: Layout,
    name: 'Create',
    props: ['meta', 'options', 'defaults'],
    data() {
        return {
            form: this.$inertia.form({
                teacher_ids: [],
                date: this.defaults.date,
                time: this.defaults.time,
                comment: '',
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.store);
        },
    },
};
</script>
